export default (that) => [
  {
    field: 'seq',
    width: 80,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.type === 'checkbox'
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: that.type === 'radio'
  },
  {
    title: that.$l('form_label_warehouseNo') || '库房编号',
    headerAlign: 'left',
    align: 'left',
    minWidth: '120',
    field: 'warehouseNo'
  },
  {
    title: that.$l('form_label_warehouseDescription') || '库房名称',
    headerAlign: 'left',
    align: 'left',
    minWidth: '200',
    field: 'warehouseDescription'
  },
  {
    title: that.$l('form_label_locationNo') || '库位编号',
    headerAlign: 'left',
    align: 'left',
    minWidth: '120',
    field: 'locationNo'
  },
  {
    title: that.$l('form_label_locationDescription') || '库位名称',
    headerAlign: 'left',
    align: 'left',
    minWidth: '200',
    field: 'locationDescription'
  },
]
